export const setDelay = (fn: () => void, ms: number) => setTimeout(fn, ms)
